<template>
  <div class="text-block block-card card-border pt-5">
    <div class="primary escalate-agent-mark"></div>
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text">headset_mic</v-icon>
            </div>

            <h4>
              Escalate To Agent 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">

            <label >Desired Queue</label>
            <v-autocomplete
              :error="data.queueName.length"
              :error-messages="data && data.queueName && !data.queueName.length? 'Please select queue name':'' "
              :items="$store.state.settings.settings.queueNames ? $store.state.settings.settings.queueNames : [] "
              v-model="data.queueName"
              outline
              v-if="$store.state.settings.settings"
              solo
            />
            <v-autocomplete
                v-else
                :error="data.queueName.length"
                :error-messages="data && data.queueName && !data.queueName.length? 'Please select queue name':'' "
                :items="[]"
                v-model="data.queueName"
                outline
                solo
            />

            <label for="">Before starting the escalation, notify the user with</label>
            <v-autocomplete
              :items="blocksList"
              v-model="data.blocksBeforeStarting"
              :error="!data.blocksBeforeStarting.length"
              :error-messages="!data.blocksBeforeStarting.length? 'Please select at least one block':'' "
              item-text="name"
              multiple
              item-value="id"
              outline
              solo
              chips
            >
              <template v-slot:selection="block">
                <v-chip
                  :selected="block.selected"
                  close
                  color="#333"
                  @input="data.blocksBeforeStarting.splice(data.blocksBeforeStarting.indexOf(block.item.id), 1)"
                >
                  <strong>{{ block.item.name }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>

            <label for="">After finishing with Agent, Redirect to</label>
            <v-autocomplete
              :items="blocksList"
              v-model="data.blocksFinishing"
              :error="!data.blocksFinishing.length"
              :error-messages="!data.blocksFinishing.length? 'Please select at least one block':'' "
              item-text="name"
              multiple
              item-value="id"
              outline
              solo
              chips
            >
              <template v-slot:selection="block">
                <v-chip
                  :selected="block.selected"
                  close
                  color="#333"
                  @input="data.blocksFinishing.splice(data.blocksFinishing.indexOf(block.item.id), 1)"
                >
                  <strong>{{ block.item.name }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>

            <label for="">If No Agent is available, Redirect to</label>
            <v-autocomplete
              :items="blocksList"
              v-model="data.blocksNotAvailable"
              :error="!data.blocksNotAvailable.length"
              :error-messages="!data.blocksNotAvailable.length? 'Please select at least one block':'' "
              item-text="name"
              multiple
              item-value="id"
              outline
              solo
              chips
            >
              <template v-slot:selection="block">
                <v-chip
                  :selected="block.selected"
                  close
                  color="#333"
                  @input="data.blocksNotAvailable.splice(data.blocksNotAvailable.indexOf(block.item.id), 1)"
                >
                  <strong>{{ block.item.name }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>

            <label for="">If Agent is not answering, Redirect to</label>
            <v-autocomplete
              :items="blocksList"
              v-model="data.blocksNotAnswering"
              :error="!data.blocksNotAnswering.length"
              :error-messages="!data.blocksNotAnswering.length? 'Please select at least one block':'' "
              item-text="name"
              multiple
              item-value="id"
              outline
              solo
              chips
            >
              <template v-slot:selection="block">
                <v-chip
                  :selected="block.selected"
                  close
                  color="#333"
                  @input="data.blocksNotAnswering.splice(data.blocksNotAnswering.indexOf(block.item.id), 1)"
                >
                  <strong>{{ block.item.name }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>
          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
export default {
  name: 'CardEscalate',
  components: {
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteImageUrlValidationrRules: [
        v => !!v || 'Queue name is required'
      ]
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {



    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style scoped>
  .escalate-agent-mark {
    height: 25px;
    border-radius: 8px 8px 0 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>
